import { render, staticRenderFns } from "./UgSerigy.vue?vue&type=template&id=0724bf38&scoped=true"
import script from "./UgSerigy.vue?vue&type=script&lang=ts"
export * from "./UgSerigy.vue?vue&type=script&lang=ts"
import style0 from "./UgSerigy.vue?vue&type=style&index=0&id=0724bf38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0724bf38",
  null
  
)

export default component.exports